import classNames from "classnames";
import type { ReactNode } from "react";

interface EmptyStateProps {
  title?: ReactNode;
  message?: ReactNode;
  icon?: string;
  className?: string;
  compact?: boolean;
}

export const EmptyState = ({
  title,
  message = "No data found",
  icon = "icon-[ph--tray]",
  className,
  compact = false,
}: EmptyStateProps) => {
  return (
    <div
      className={classNames(
        "col-span-12 flex w-full flex-col items-center justify-center",
        compact ? "py-6" : "py-10",
        className
      )}
    >
      <div className="relative w-full max-w-xl overflow-hidden rounded-3xl border border-white/30 bg-white/30 px-6 py-8 text-center shadow-[0_20px_55px_-35px_rgba(15,23,42,0.65)] backdrop-blur-2xl dark:border-primary-800/70 dark:bg-gradient-to-b dark:from-content-900 dark:to-primary-950/70">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(120%_85%_at_8%_0%,rgba(255,255,255,0.75)_0%,rgba(255,255,255,0.22)_44%,rgba(255,255,255,0.06)_100%)] dark:hidden" />
        <div className="pointer-events-none absolute -right-16 -top-12 h-28 w-28 rounded-full bg-accent-200/35 blur-2xl dark:hidden" />
        <div className="pointer-events-none absolute -bottom-14 -left-14 h-32 w-32 rounded-full bg-primary-300/25 blur-2xl dark:hidden" />

        <div className="relative mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl border border-white/40 bg-white/55 text-primary-700 shadow-inner backdrop-blur-md dark:border-primary-800/40 dark:bg-primary-950/45 dark:text-primary-200">
          <span className={classNames(icon, "h-8 w-8")} />
        </div>

        {title && (
          <div className="relative mb-2 font-header text-lg text-content-900 dark:text-content-100">
            {title}
          </div>
        )}

        <div className="relative font-sans text-sm text-content-700 dark:text-content-300 sm:text-base">
          {message}
        </div>
      </div>
    </div>
  );
};
